import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, Form, FormikProps } from 'formik';
import { Button, Grid, IconButton, Typography } from '@material-ui/core';

import { DeleteIcon, ValidatedTextField } from 'components';
import { IDepartmentLocation } from 'features/admin/types';

interface IProps {
  titleKey: string;
  inputPlaceholderKey: string;
}

interface IPropsEnhanced extends IProps {
  formik: FormikProps<IDepartmentLocation>;
}

const CreateForm: FC<IPropsEnhanced> = props => {
  const { t } = useTranslation();

  const { formik, titleKey, inputPlaceholderKey } = props;

  function renderClear() {
    const { values } = formik;
    const { title } = values;

    if (!title) {
      return null;
    }

    return (
      <Grid item xs={1}>
        <IconButton onClick={() => formik.resetForm()}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    );
  }

  return (
    <Form>
      <Grid container alignItems="center" spacing={3}>
        <Grid item xs={3}>
          <Typography variant="subtitle2">{t(titleKey)}</Typography>
        </Grid>
        <Grid item xs={7}>
          <Grid container alignItems="center">
            <Grid item xs={11}>
              <ValidatedTextField
                name="title"
                i18nKey={inputPlaceholderKey}
                color="primary"
                TextFieldProps={{ margin: 'none', label: null }}
              />
            </Grid>
            {renderClear()}
          </Grid>
        </Grid>
        <Grid item xs={2}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {t('common:add')}
          </Button>
        </Grid>
      </Grid>
    </Form>
  );
};

export default connect<IProps>(CreateForm);
